import { injectable } from '~/container'
import { GeoCoordinates, GeolocationError } from './schema'
import { GeolocationService } from './services'

@injectable()
export class NavigatorGeolocationService implements GeolocationService {
  async getCoordinates(): Promise<GeoCoordinates | GeolocationError> {
    try {
      const cooridnates: GeolocationPosition = await this.getNavigatorPromise()
      return {
        lat: parseFloat(cooridnates.coords.latitude.toFixed(4)),
        lng: parseFloat(cooridnates.coords.longitude.toFixed(4)),
      }
    } catch (err) {
      return Promise.reject(
        this.mapGeolocationError(err as GeolocationPositionError),
      )
    }
  }

  getNavigatorPromise(): Promise<GeolocationPosition> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject)
    })
  }

  mapGeolocationError({ code }: GeolocationPositionError): GeolocationError {
    const geolocationErrors: Record<number, GeolocationError> = {
      1: 'denied',
      2: 'unavailable',
      3: 'timeout',
    }
    return geolocationErrors[code] || 'unavailable'
  }
}
